export function handleClickWithoutDragging(view, action) {
    const tolerance = 20;
    let pointerDownPosition;
    view.addListener('pointerdown', (e)=>{
        pointerDownPosition = e.global;
    });
    view.addListener('pointerup', (e)=>{
        const mousePosition = e.global;
        if (pointerDownPosition == undefined) return;
        if (Math.abs(mousePosition.x - pointerDownPosition.x) > tolerance || Math.abs(mousePosition.y - pointerDownPosition.y) > tolerance) {
            return;
        }
        action();
    });
}
